import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import './BlancoDeCazador.scss';
import { Error } from '../../components/Error/Error.jsx';
import { Loader } from '../../components/Loader/Loader.jsx';
import { API_URL } from '../../config';
import { moveBarOfSummary } from '../shared/js/auxFunctions.js';

export const BlancoDeCazador = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [bdcData, setBdcData] = useState([]);

	const getData = async () => {
		try {
			setLoading(true);
			setError(null);

			const url = `${API_URL}/bdc`;
			const { data: response } = await axios.get(url);

			setBdcData(response.data);
		} catch (error) {
			console.error(error);
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div className='BlancoDeCazador'>
			<div className='bdc-img-container'>
				<img
					src={require(`../../assets/img/bdc_1.jpg`)}
					alt='fotografía de Iván Blanco'
				/>
				<img
					src={require(`../../assets/img/bdc_2.jpg`)}
					alt='fotografía de Iván Blanco'
				/>
				<img
					src={require(`../../assets/img/bdc_3.jpg`)}
					alt='fotografía de Iván Blanco'
				/>
			</div>

			<div className='bdc-text-container'>
				<div className='bdc-text-inner-container'>
					<p>
						Blanco Decazador, solo project by the artist based in
						Galicia and born in Canary Islands, Iván Blanco (1982).{' '}
						<span>
							<Link to='/about'>&lt;--</Link>
						</span>
					</p>

					{error && <Error error={error} setError={setError} />}
					{loading && <Loader />}

					{bdcData.map((item, index) => (
						<div key={item._id}>
							<details onClick={(e) => moveBarOfSummary(e)}>
								<summary>
									{item.title}
									<span>/</span>
								</summary>
								<div
									dangerouslySetInnerHTML={{
										__html: item.description,
									}}
								></div>
							</details>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
